export const ROLE_NANNY = 'NANNY'
export const ROLE_FAMILY = 'FAMILY'
